import { small } from 'constants/fonts';
import Device from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

import { containerStyle } from '../../styles';

export default {
  container: {
    ...containerStyle
  },
  form: {
    width: appConfig.signUp.personalInformationFullWidthFields ? '100%' : '55vw',
    [Device.mobile]: {
      width: '100%'
    }
  },
  submit: {
    textTransform: 'uppercase',
    marginTop: 20
  },
  termsContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'scroll',
    border: `1px solid ${appConfig.colors.signupBackground}`,
    backgroundColor: appConfig.colors.signupBackground,
    width: '100%',
    paddingRight: 5,
    boxSizing: 'border-box',
    maxHeight: 200
  },
  terms: {
    fontSize: small,
    textAlign: 'center'
  },
  accounts: {
    maxHeight: '25vh',
    width: '100%',
    overflow: 'auto'
  }
};
